import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import React from 'react'

import { withFormContext } from '../../../lib/form-context'
import { withDiscardDialog } from '../../../lib/global-discard-dialog'
import { Button } from '../NarusMaterial'

@withFormContext
@withDiscardDialog
export class SaveButton extends React.Component {
  constructor (props) {
    super(props)
    this.handleOnClick = this.handleOnClick.bind(this)
    this.errorsCheck = this.errorsCheck.bind(this)
  }

  static contextTypes = {
    form: PropTypes.instanceOf(Object),
    formKey: PropTypes.string
  }

  static defaultProps = {
    label: 'SAVE',
    disabled: false,
    ignoreGlobalDisable: false
  }

  handleOnClick () {
    const { form } = this.context
    const { onClick, discardDialog, formKey } = this.props

    discardDialog.resetForm(formKey)

    if (onClick) {
      if (form?.validate()) {
        onClick(form.getValue())
      } else {
        onClick()
      }
    }
  }

  errorsCheck (errors) {
    const valueCheck = arr => {
      if (!arr || !arr.length) {
        return []
      }
      return arr.reduce((total, val) => {
        if (val) {
          return total + 1
        }
      }, 0)
    }

    if (_.isEmpty(errors)) {
      return false
    }
    const keys = Object.keys(errors)
    if (!keys.length) {
      return false
    }
    const numberOfErrors = keys.filter(k => {
      const hasVal = valueCheck(errors[k])
      if (errors[k] && errors[k].length && hasVal) {
        return k
      }
    })

    if (numberOfErrors.length > 0) {
      return true
    }
    return false
  }

  render () {
    let { label, disabled, ignoreGlobalDisable, discardDialog, formKey } = this.props
    let { form } = this.context
    let isDirty = discardDialog.isFormDirty(formKey)
      let hasErrors = this.errorsCheck(form?.state?.errors)

    const isDisabled = (ignoreGlobalDisable ? false : !isDirty) ||
      disabled ||
      hasErrors

    return (
      <Button
        purple
        label={label}
        long
        disabled={isDisabled}
        onClick={this.handleOnClick}
      />
    )
  }
}
